import React from 'react';
import isWithinInterval from 'date-fns/isWithinInterval';
import get from 'lodash/get';
import usePeriodByDateRange from './usePeriodByDateRange';

export default function useCurrentWeek({ dateNow: dateNowTmp }) {
  const dateNow =
    dateNowTmp && dateNowTmp instanceof Date && !isNaN(dateNowTmp)
      ? dateNowTmp
      : new Date();

  const fromDate = React.useMemo(() => {
    console.log(dateNowTmp);
    return dateNow;
  }, [dateNow, dateNowTmp]);

  const { periodList, loading } = usePeriodByDateRange({
    fromDate,
    range: 16
  });

  console.log('>>hooks/useCurrentWeek::', 'periodList', periodList); //TRACE
  const { period, previousPeriod, nextPeriod } = React.useMemo(() => {
    console.log('>>hooks/useCurrentWeek::', 'dateNowTmp', dateNowTmp); //TRACE
    const periodIndex = periodList.findIndex(p => {
      return isWithinInterval(dateNow, {
        start: new Date(p.dateFrom),
        end: new Date(p.dateTo)
      });
    });
    console.log('>>hooks/useCurrentWeek::', 'periodIndex', periodIndex); //TRACE
    return {
      period: periodList[periodIndex],
      previousPeriod: get(periodList, `${periodIndex + 1}`),
      nextPeriod: get(periodList, `${periodIndex - 1}`)
    };
  }, [periodList, dateNow, dateNowTmp]);
  return { period, previousPeriod, nextPeriod, loading };
}
